import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaInstagram, FaFacebook, FaShoppingCart } from 'react-icons/fa';

const SocialLinks = () => {
  // Substitua estes URLs pelos links reais
  const links = [
    {
      id: 'whatsapp',
      title: 'Faça seu pedido pelo WhatsApp',
      url: 'https://wa.me/5541996081142',  
      icon: <FaWhatsapp size={20} />,
      delay: 0.2,
    },
    {
      id: 'pedido',
      title: 'Faça seu pedido online',
      url: 'https://porterhouse-carnes.onbeef.app.br/',  
      icon: <FaShoppingCart size={20} />,
      delay: 0.4,
    },
    {
      id: 'instagram',
      title: 'Siga no Instagram',
      url: 'https://instagram.com/porterhousecarnes', 
      icon: <FaInstagram size={20} />,
      delay: 0.6
    },
    {
      id: 'facebook',
      title: 'Curta no Facebook',
      url: 'https://facebook.com/porterhousecarnes',  // Substitua pelo Facebook correto
      icon: <FaFacebook size={20} />,
      delay: 0.8
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <motion.div 
      className="container mx-auto px-4 mb-10 max-w-xl"
      variants={container}
      initial="hidden"
      animate="show"
    >
      {links.map((link) => (
        <motion.a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between w-full py-3 px-6 mb-4 bg-black border border-gold rounded-full hover:shadow-[0_0_15px_rgba(234,179,8,0.6)]"
          variants={item}
          whileHover={{ 
            scale: 1.02,
          }}
          whileTap={{ scale: 0.98 }}
          style={{
            boxShadow: '0 0 6px rgba(234, 179, 8, 0.3)'
          }}
        >
          <div className="flex items-center text-gold">
            <div className="w-10 h-10 rounded-full bg-black border border-gold flex items-center justify-center mr-4"
              style={{ boxShadow: '0 0 8px rgba(234, 179, 8, 0.4)' }}>
              <motion.div
                className="text-gold"
                whileHover={{ scale: 1.2 }}
                transition={{ duration: 0.3 }}
              >
                {link.icon}
              </motion.div>
            </div>
            <span className="font-medium">{link.title}</span>
          </div>
          
          <motion.div 
            className="w-8 h-8 bg-gold rounded-full flex items-center justify-center"
            whileHover={{ rotate: 90 }}
            transition={{ duration: 0.2 }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-black">
              <path fillRule="evenodd" d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z" clipRule="evenodd" />
            </svg>
          </motion.div>
        </motion.a>
      ))}
    </motion.div>
  );
};

export default SocialLinks; 